import Vue from 'vue';
import HiverApi from 'widget/api/hiver';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import { sendExceptionToSentry } from 'shared/helpers/sentry';

const state = {
  records: [],
  uiFlags: {
    isError: false,
    isLoading: false,
    hasFetched: false,
  },
};

export const getters = {
  getHasFetched: ($state) => $state.uiFlags.hasFetched,
  availableAgents: ($state) =>
    $state.records.filter((agent) => agent.availability_status === 'online'),
  allAgents: ($state) => $state.records,
  getIsLoading: ($state) => $state.uiFlags.isLoading,
};

export const actions = {
  fetchAvailableAgents: async ({ commit }, websiteToken) => {
    try {
      commit('setIsLoading', true);
      const { data } = await HiverApi.getAvailableAgents(websiteToken);
      const { payload = [] } = data;
      commit('setAgents', payload);
      commit('setError', false);
      commit('setHasFetched', true);
    } catch (error) {
      commit('setError', true);
      commit('setHasFetched', true);
      sendExceptionToSentry(error);
    } finally {
        commit('setIsLoading', false);
    }
  },
  updatePresence: async ({ commit }, data) => {
    commit('updatePresence', data);
  },
};

export const mutations = {
  setAgents($state, data) {
    Vue.set($state, 'records', data);
  },
  updatePresence: MutationHelpers.updatePresence,
  setError($state, value) {
    Vue.set($state.uiFlags, 'isError', value);
  },
  setHasFetched($state, value) {
    Vue.set($state.uiFlags, 'hasFetched', value);
  },
  setIsLoading($state, value) {
    Vue.set($state.uiFlags, 'isLoading', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
